<template>
  <ModalOverlay
    id="popUpOverlay"
    title=""
    :width="width"
  >
    <template #body>
      <div class="grid-x">
        <div class="cell">
          <PopUpContent :mediacontent="mediacontent" />
        </div>
      </div>
    </template>
  </ModalOverlay>
</template>

<script setup>

import { onUpdated, computed } from 'vue';
import { ModalOverlay, SET_MODAL_OVERLAY_VISIBILITY } from '@atomic-ui/modalOverlay';
import { useStore } from 'vuex';
import PopUpContent from './PopUpContent';

const props = defineProps({
  mediacontent: {
    type: Object,
    default: () => {},
  },
});

const store = useStore();
const toggleModal = () => {
  store.commit(
    `modalOverlayStore/${SET_MODAL_OVERLAY_VISIBILITY}`,
    'popUpOverlay',
  );
};

// eslint-disable-next-line no-undef
defineExpose({
  toggleModal,
});

const width = computed(() => {
  const overlayContentWidthMap = {
    small: '33.33%',
    medium: '50%',
    large: '66.66%',
  };
  return overlayContentWidthMap[props.mediacontent?.attributes?.layout];
});

onUpdated(() => {
  /* istanbul ignore next */
  if (props.mediacontent?.attributes) {
    document.querySelector('#popUpOverlay.v-overlay-wrapper .v-overlay-content').style.background = props.mediacontent.attributes?.bgColor;
  }
});

</script>

<style lang="scss">
@include breakpoint(medium down) {
  #popUpOverlay.v-overlay-wrapper .v-overlay-content {
    padding:rem-calc(32x) rem-calc(20px);
  }
}
@include breakpoint(small down) {
  #popUpOverlay.v-overlay-wrapper .v-overlay-content {
    padding:rem-calc(24x) rem-calc(20px);
  }

#popUpOverlay.v-overlay-wrapper .v-overlay-body::-webkit-scrollbar {
    width: 0 !important
}
#popUpOverlay.v-overlay-wrapper .v-overlay-body {
    overflow: -moz-scrollbars-none;
}
#popUpOverlay.v-overlay-wrapper .v-overlay-body {
    -ms-overflow-style: none;
}
}

@include breakpoint(medium up) {
#popUpOverlay.v-overlay-wrapper .v-overlay-content .v-overlay-body{
    overflow-y:hidden;
  }
}
</style>
